import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

const SECTIONS = [
  ["About", [["first_name", "First name *"], ["last_name", "Last name *"], ["preferred_name", "Preferred name"], ["date_of_birth", "Date of birth", "date"], ["school", "School"], ["grade", "Grade / Year"], ["interests", "Preferred activities"]]],
  ["Contacts & pickup", [["guardian_name", "Parent / guardian"], ["parent_phone", "Parent phone"], ["secondary_guardian", "Secondary guardian"], ["emergency_contact", "Emergency contact"], ["emergency_phone", "Emergency phone"], ["authorized_pickups", "Authorized pickups"]]],
  ["Safety & care", [["allergies", "Allergies"], ["allergy_severity", "Allergy severity"], ["allergy_instructions", "Allergy instructions"], ["dietary", "Dietary restrictions"], ["foods_to_avoid", "Foods to avoid"], ["medical", "Medical info"], ["medications", "Medications"], ["special_support", "Special support"]]],
  ["Get to know me", [["favorite_color", "Favourite colour"], ["favorite_animal", "Favourite animal"], ["favorite_food", "Favourite food"], ["favorite_activity", "Favourite thing to do"], ["when_i_grow_up", "When I grow up…"], ["superpower", "Superpower"]]],
];
const KEYS = SECTIONS.flatMap(([, f]) => f.map(([k]) => k));
const blank = () => Object.fromEntries(KEYS.map((k) => [k, ""]));

export const ExplorerProfileForm = ({ open, parentId, child, onClose, onSaved }) => {
  const [f, setF] = useState(blank());
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF({ ...blank(), ...Object.fromEntries(KEYS.map((k) => [k, child?.[k] || ""])) }); }, [open, child]);
  const save = async () => {
    if (!f.first_name.trim() || !f.last_name.trim()) return toast.error("First and last name are required.");
    setBusy(true);
    try {
      const { data } = child?.id ? await api.put(`/admin/children/${child.id}`, f) : await api.post("/admin/enroll/child", { ...f, parent_id: parentId });
      toast.success(child?.id ? "Explorer profile updated" : `Added ${data.first_name}`);
      onSaved && onSaved(data);
    } catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto" data-testid="explorer-profile-form">
        <DialogHeader><DialogTitle className="font-display text-navy">{child?.id ? "Edit Explorer profile" : "Add Explorer profile"}</DialogTitle></DialogHeader>
        {SECTIONS.map(([title, fields]) => (
          <div key={title} className="space-y-2">
            <p className="text-xs font-bold text-navy uppercase tracking-wider">{title}</p>
            <div className="grid sm:grid-cols-2 gap-2">
              {fields.map(([k, l, type]) => (
                <div key={k}>
                  <Label className="text-[10px] text-slate-500">{l}</Label>
                  <Input type={type || "text"} list={k === "school" ? "profile-school-list" : undefined} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="rounded-lg h-9" data-testid={`profile-${k}`} />
                </div>
              ))}
            </div>
          </div>
        ))}
        <datalist id="profile-school-list"><option value="Prospect Preschool" /></datalist>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" className="rounded-full" onClick={onClose} data-testid="profile-cancel">Cancel</Button>
          <Button disabled={busy} onClick={save} className="rounded-full bg-turquoise text-navy font-bold" data-testid="profile-save">{child?.id ? "Save changes" : "Add Explorer"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
